import mitt from 'mitt'

/**
 * Global realtime event bus.
 *
 * The realtime plugin (see `./realtime.js`) is subscribed to every channel the
 * user's token grants and re-emits every incoming message on this bus. Vue
 * components listen via `this.$realtimeBus.$on('<event-name>', handler)` in
 * `mounted()` and `$off` in `beforeDestroy()` — no channel management in the
 * components themselves.
 *
 * Event names match the server-side envelope's `event` field (e.g. 'new-lesson',
 * 'refresh-groups', 'board-item-created').
 *
 * Bus payload shape:
 *   { channel: string, data: any, clientId: string, timestamp: number }
 *
 * The `channel` field lets scoped components disambiguate (e.g. a board view
 * that only cares about its own `board:<id>` events).
 *
 * Was a Vue-instance emitter in Vue 2; mitt is the Vue-3-compatible replacement. The
 * `$on` / `$off` / `$emit` aliases preserve the legacy Vue-2 call sites until
 * the Phase 5 codemod migrates them to native `on` / `off` / `emit`.
 */
const bus = mitt()
bus.$on = bus.on
bus.$off = bus.off
bus.$emit = bus.emit

export default {
    install(app) {
        app.config.globalProperties.$realtimeBus = bus
    },
}

export { bus }
